const WORDS = [
  "Aluminum Polishing",
  "Fleet Washing",
  "Mobile Service",
  "Nova Scotia",
  "Chrome Shine",
  "Interior Detailing",
];

export const Marquee = () => {
  const row = [...WORDS, ...WORDS];
  return (
    <div className="border-y border-border py-6 md:py-8 overflow-hidden bg-background" data-testid="marquee">
      <div className="animate-marquee flex items-center gap-10 will-change-transform">
        {row.map((w, i) => (
          <div key={i} className="flex items-center gap-10 shrink-0">
            <span className="font-display uppercase tracking-tight text-3xl md:text-5xl text-outline">
              {w}
            </span>
            <span className="text-muted-foreground text-2xl">✦</span>
          </div>
        ))}
      </div>
    </div>
  );
};
